import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { handleExport } from '../../../../../../helpers/export'
import BankService from '../../core/BankService'

export const getBusinessGrowthBankThunk = createAsyncThunk(
  'companyAnalysis/industryAnalysis/bank/businessGrowth/getBusinessGrowthBankThunk',
  async (params, { rejectWithValue }) => {
    try {
      const res = await BankService.postBusinessGrowth(params)

      return res.success ? res.data : rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)

export const downloadBusinessGrowth = createAsyncThunk(
  'companyAnalysis/industryAnalysis/bank/businessGrowth/export',
  async (params) => {
    try {
      const res = await BankService.downloadBusinessGrowth(params)
      handleExport(res.data, res.filename)
    } catch (error) {
      console.log(error)
    }
  },
)
